import { Link } from 'react-router-dom'
import { 
  HomeIcon, TagIcon, UsersIcon, UserIcon, UserGroupIcon, ClipboardDocumentCheckIcon,
  DocumentIcon
} from '@heroicons/react/24/solid'
import { ORDERS } from '../../data/Orders'
import { PRODUCTS } from '../../data/Products'
import { CATEGORIES } from '../../data/Categories'
import View from './management/orders/view'

export default function Dashboard() {


return(
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <Link to={`/admin/categories`}>
          <div className="flex items-center justify-between p-4 lg:p-8 rounded-xl  bg-black border-r-4 border-gray-500 shadow">
            <div className='text-white'>
              <TagIcon className='w-8 sm:w-10'/>
              <span>Catégories</span>
            </div>
            <p className="text-4xl font-semibold text-white">{CATEGORIES.length}</p>
          </div>
        </Link>
        <Link to={`/admin/products`}>
          <div className="flex items-center justify-between p-4 lg:p-8 rounded-xl  bg-black border-r-4 border-gray-500 shadow">
            <div className='text-white'>
              <DocumentIcon className='w-8 sm:w-10'/>
              <span>Produits</span>
            </div>
            <p className="text-4xl font-semibold text-white">{PRODUCTS.length}</p>
          </div>
        </Link>
        <Link to={`/admin/orders`}>
          <div className="flex items-center justify-between p-4 lg:p-8 rounded-xl  bg-black border-r-4 border-gray-500 shadow">
            <div className='text-white'>
              <ClipboardDocumentCheckIcon className='w-8 sm:w-10'/>
              <span>Commandes</span>
            </div>
            <p className="text-4xl font-semibold text-white">{ORDERS.length}</p>
          </div>
        </Link>
        {/* <Link to={`/admin/customers`}>
          <div className="flex items-center justify-between p-4 lg:p-8 rounded-xl  bg-black border-r-4 border-gray-500 shadow">
            <div className='text-white'>
              <UserGroupIcon className='w-8 sm:w-10'/>
              <span>Clients</span>
            </div>
            <p className="text-4xl font-semibold text-white">5</p>
          </div>
        </Link> */}
      </div>

      <div>
        <div className='flex justify-between items-center px-2 py-5'>
          <h2 className='text-lg font-medium leading-7 text-gray-900'>Commandes recentes</h2>
          <Link to={`/admin/orders`} className='text-sm hover:font-medium text-gray-900'>Voir tous</Link>
        </div>
        <div className="bg-white relative shadow-md sm:rounded-lg overflow-auto lg:overflow-visible">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-900 uppercase bg-gray-100 ">
                    <tr>
                        <th scope="col" className="px-4 py-4">Commande</th>
                          <th scope="col" className="px-4 py-3">Client</th>
                          <th scope="col" className="px-4 py-3">Prix total</th>
                          <th scope="col" className="px-4 py-3">
                          <span className="sr-only">Actions</span>
                        </th>
                    </tr>
                  </thead>
                  <tbody>
                    { ORDERS.map((item, index) => index < 10 && (
                      <tr className="border-b ">
                        <th scope="row" className="px-4 py-3 font-medium text-gray-900 whitespace-nowrap ">{item.id}</th>
                            <td className="px-4 py-3 max-w-[12rem] truncate">{item.customer}</td>
                            <td className="px-4 py-3 max-w-[12rem] truncate">{item.total_price}$</td>
                            <td className="px-4 py-3  flex items-center justify-end">
                              <View order={item} />
                            </td>
                      </tr>
                    ))}
                  </tbody>
              </table>
            </div>
          </div>
      {/* <div className="grid grid-cols-2 gap-4 mb-4">
        <div
          className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 h-48 md:h-72"
        ></div>
        <div
          className="border-2 border-dashed rounded-lg border-gray-300 dark:border-gray-600 h-48 md:h-72"
        ></div>
      </div> */}
      
  </>
)
}